<template>
  <th :is="tag" :class="cssClass" @click="change">
    <slot></slot>
    <span v-if="!disabled" class="c-btn c-btn--sort"></span>
    <slot name="tooltip"></slot>
  </th>
</template>

<script>
export default {
  model: {
    prop: 'params',
    event: 'change'
  },
  props: {
    name: {
      type: String,
      required: true
    },
    orderby: {
      type: String,
      required: true
    },
    params: {
      type: Object,
      required: true
    },
    tag: {
      type: String,
      required: false,
      default: 'th'
    },
    type: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    cssClass() {
      return {
        'is-sortable': true,
        ['is-' + this.params.orderby]: this.isActive
      };
    },
    isActive() {
      return this.params.name === this.name;
    }
  },
  methods: {
    change() {
      if (this.disabled) {
        return;
      }
      const params = {
        name: this.name,
        orderby: this.orderby,
        type: this.type
      };
      if (this.isActive) {
        if (this.params.orderby === 'desc') {
          params.orderby = 'asc';
        } else {
          params.orderby = 'desc';
        }
      }
      this.$emit('change', params);
    }
  }
};
</script>
